import clsx from 'clsx'

import { FvNum, Icon } from '@fv/client-components'
import type { FullShipment, PropsWithClassName } from '@fv/client-types'

import { ShipperTooltip } from '@/components/ShipperTooltip'

import { HideForVendor } from '../auth/HasRole'

export const VendorShipmentIcon = () => {
  return <Icon icon="store-alt" className="text-fv-orange" />
}

type Props = PropsWithClassName<{
  name?: string
}>
export const VendorShipmentListIndicator = ({ className, name }: Props) => {
  return (
    <HideForVendor>
      <ShipperTooltip label={`Vendor shipment ${name ? ` / ${name}` : ''}`}>
        <div
          className={clsx(
            'flex items-center px-2 bg-fv-blue-25 border-l border-l-fv-gray',
            className,
          )}
        >
          <VendorShipmentIcon />
        </div>
      </ShipperTooltip>
    </HideForVendor>
  )
}

type MarkupProps = PropsWithClassName<{
  load: Pick<FullShipment, 'vendor' | 'selectedQuote'>
  label?: string
  noIcon?: boolean
}>
export const VendorMarkupDescription = ({
  noIcon,
  load,
  className,
  label = 'Vendor price w/ markup',
}: MarkupProps) => {
  if (
    !load.vendor?.quoteAmount ||
    load.selectedQuote?.amount === load.vendor.quoteAmount
  ) {
    return null
  }
  return (
    <div className={className}>
      {!noIcon && <Icon icon="dollar-sign" className="text-fv-gray-dark" />}
      <span>
        {label}{' '}
        <FvNum
          currency={load.selectedQuote?.currency}
          val={load.vendor.quoteAmount}
        />
      </span>
    </div>
  )
}
